import { render, staticRenderFns } from "./InvoiceFooter.vue?vue&type=template&id=127850d3&scoped=true"
import script from "./InvoiceFooter.vue?vue&type=script&lang=js"
export * from "./InvoiceFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127850d3",
  null
  
)

export default component.exports